import { render, staticRenderFns } from "./plat.vue?vue&type=template&id=4ef3109e&scoped=true&"
import script from "./plat.vue?vue&type=script&lang=js&"
export * from "./plat.vue?vue&type=script&lang=js&"
import style0 from "./plat.vue?vue&type=style&index=0&id=4ef3109e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef3109e",
  null
  
)

export default component.exports